import { render } from "./ChooseButton.vue?vue&type=template&id=53ca6e39&scoped=true"
import script from "./ChooseButton.vue?vue&type=script&scoped=true&lang=js"
export * from "./ChooseButton.vue?vue&type=script&scoped=true&lang=js"

import "./ChooseButton.vue?vue&type=style&index=0&id=53ca6e39&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ca6e39"]])

export default __exports__